// src/components/Footers/FooterSmallNew.js
import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../Homepage/LanguageContext";
import logodeliciko from "../../assets/img/logodeliciko.png";
import medterrannefoodlogo from "assets/img/medterrannefoodlogo.png";
import mailicon from "assets/img/mailicon.png";
import phoneicon from "assets/img/phoneicon.png";
import facebookicon1 from "assets/img/facebookicon1.png";
import instagramicon1 from "assets/img/instagramicon1.png";

export default function FooterSmallNew() {
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();

  const handleButtonClick = () => {
    window.location.href = "tel:+919036323422";
  };

  const handleButtonClickMail = () => {
    window.location.href = "mailto:info@elegantcarve.com";
  };

  const handleChangeLanguage = (lang) => {
    changeLanguage(lang);
  };

  // year change automatically
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="relative bottom-0">
        <section
          style={{
            backgroundColor: "#160935",
            backgroundSize: "cover",
          }}
          className=""
        >
          <div className="container mx-auto overflow-hidden xl:px-24 px-4 py-8 xl:py-16 w-12/12 md:flex flex-none">
            <div className="md:w-3/12 md:px-0 px-4 md:pt-0 pt-12">
              <img
                src={medterrannefoodlogo}
                className="xl:w-48 w-32"
                alt="Deliciko Logo"
              />
            </div>
            <div className="md:w-5/12 px-4">
              <p className="text-white xl:text-base1 xl:pl-20 md:pl-8  md:pt-0 pt-8 text-base banner-font">
                {t("footer.description")}
              </p>
            </div>
            <div className=" md:pt-0 pt-8 xl:ml-38 lg:ml-36 md:ml-12 ml-4">
              {/* <div className=" flex">
                <div>
                  <img class="w-4 mt-1" src={phoneicon} />
                </div>
                <p className="ml-2 text-white text-base1 font-semibold banner-font no-outline">
                  +1 (438) 988-1743{" "}
                </p>
              </div> */}

              <div className="flex items-center">
                <div>
                  <img class="w-10 mt-3" src={mailicon} />
                </div>
                <p className="text-white text-base1 font-semibold banner-font no-outline pt-2 ml-2">
                  info@mediterraneefood.com{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="container mx-auto overflow-hidden md:flex xl:px-24 px-4 flex-none justify-between">
            <div className="md:pt-0 pt-6 xl:px-0 lg:px-0 md:px-0 px-4">
              <h1 className="text-left text-white banner-font text-sm py-4 ">
                ©{currentYear}
                <span className="font-bold">Mediterranee Food</span>,{" "}
                {t("footer.allRightsReserved")}
              </h1>
            </div>
            <div>
              <div className=" flex justify-end mt-2 px-4 pb-12 xl:pb-0 lg:pb-0 md:pb-0 xl:ml-0 ">
                <div className="">
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img
                      className=" w-6 "
                      src={facebookicon1}
                      alt="Facebook icon"
                    />
                  </a>
                </div>
                <div>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-6 xl:ml-2 lg:ml-4 md:ml-2 ml-2"
                      src={instagramicon1}
                      alt="Instagram icon"
                    />
                  </a>
                </div>
               
              </div>
            </div>
          </div>
        </section>
      </footer>
    </>
  );
}
